import React from "react";

interface PercentageType {
  percentage: number;
  title: string;
}

export default function PercentageCard({ percentage, title }: PercentageType) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        padding: "10px",
        color: "#fff",
        height: "50px",
      }}
    >
      <div
        style={{
          backgroundColor: "#1565C0",
          color: "#fff",
          padding: "7px",
          borderRadius: "0 5px 5px 0",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        {percentage}%
      </div>
      <div
        style={{
          backgroundColor: "#1D4A87",
          color: "#fff",
          padding: "7px",
          borderRadius: "5px 0 0 5px",
          whiteSpace: "nowrap",
          flexGrow: 1,
        }}
      >
        {title}
      </div>
    </div>
  );
}
